import { z } from 'zod/v4';

export const restStopLocationSchema = z.object({
  restStopLocationId: z.number(),
  restStopLocationValue: z.string(),
});

export type RestStopLocation = z.infer<typeof restStopLocationSchema>;
